import { render } from "./DailyReview.vue?vue&type=template&id=f774f67c&scoped=true"
import script from "./DailyReview.vue?vue&type=script&lang=js"
export * from "./DailyReview.vue?vue&type=script&lang=js"

import "./DailyReview.vue?vue&type=style&index=0&id=f774f67c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f774f67c"]])

export default __exports__